import styled from "styled-components";

export const Button = styled.button`
  width: 300px;
  height: 50px;
  border: 0;
  border-radius: 10px;
  background-color: ${(props) => props.backgroundColor};
  color: white;
  font-size: ${(props) => props.fontSize};
  cursor: pointer;
`;

export const ReturnBtn = styled.button`
  width: 50px;
  height: 35px;
  border: 0;
  border-radius: 10px;
  background-color: #212529;
  color: white;
  font-size: ${(props) => props.fontSize};
  cursor: pointer;
`;

export const EditAndDeleteBtn = styled.button`
  width: 140px;
  height: 50px;
  border: ${(props) => props.border};
  border-radius: 10px;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.fontColor};
  font-size: 20px;
  cursor: pointer;
`;
